import styled from "styled-components";
import { SearchOutlined } from "@ant-design/icons";
import { SearchWrapperProps } from "./types";

// Search Input Styles
export const SearchWrapper = styled.div<SearchWrapperProps>`
  position: relative;
  width: ${(props) => props.width || "251px"};
`;

export const SearchInput = styled.input<{ theme?: string }>`
  background-color: ${(props) => (props.theme === "dark" ? "#1a202c" : "#eee")};
  border: ${(props) => (props.theme === "dark" ? "1px solid #718096" : "0")};
  border-radius: 8px;
  font-size: 14px;
  height: 36px;
  outline: none;
  padding: 8px 10px 8px 36px;
  width: 100%;
  color: ${(props) => (props.theme === "dark" ? "#fff" : "inherit")};

  &::placeholder {
    color: ${(props) => (props.theme === "dark" ? "#8c8c8c" : "#aaa")};
  }

  &:focus {
    background-color: ${(props) => (props.theme === "dark" ? "#1a202c" : "#fff")};
    border: 1px solid #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }
`;

export const SearchIcon = styled(SearchOutlined)<{ theme?: string }>`
  color: ${(props) => (props.theme === "dark" ? "#8c8c8c" : "#aaa")};
  font-size: 16px;
  left: 12px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
`;

export const SearchClearButton = styled.button<{ theme?: string }>`
  background: none;
  border: 0;
  color: ${(props) => (props.theme === "dark" ? "#8c8c8c" : "#999")};
  cursor: pointer;
  font-size: 16px;
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 20px;
  height: 20px;
  transition: color 0.2s ease;

  &:hover {
    color: ${(props) => (props.theme === "dark" ? "#fff" : "#666")};
  }

  &:active {
    color: ${(props) => (props.theme === "dark" ? "#fff" : "#333")};
  }
`;


